import { h, Component } from 'preact'
import { connect } from 'react-redux';
import Spinner from '../component/Spinner';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants'
import qrCodeService from '../service/qrCodeService';
import QRCodesModal from "./QRCodesModal";
import util, { getQRCodeDynamicUrl, copyText } from '../util';
import store from "../store";
import memberService from '../service/memberService';
import SaveModal from './SaveModal';
import moment from 'moment';
import { EllipsisOutlined } from "@ant-design/icons";
import CreateQRDesignModal from "./CreateQRDesignModal";
import dashboardService from '../service/dashboardService';
import newOOService from '../service/newOOService';
import ooService from '../service/ooService';

export default @connect(reduce, actions)
class AsideQRCodes extends Component {
  constructor(props) {
    super();
    this.state = {
      isLoading: false,
      isQRCodesModalOpen: false,
      isCreateQRDesignModalOpen: false,
      isSaveModalOpen: false,
      createQRAfterSharing: false,
      mode: '',
      customUrl: '',
      omLocationData: {},
      qrCodes: [],
      qrCodesCopied: {},
      qrCodesImages: [],
      qrCode: '',
      qrCodeType: '',
      landingPageId: '',
      freemiumRemainingScans: constants.MAX_COUNT_FREEMIUM
    };

    this.loadQRCodes = (triggerClick = false) => {
      this.setState({ isLoading: true });

      qrCodeService.getLocationQRCodes(this.props.memberId, this.props.locationId, new Date()).then(((resp) => {
        const qrCodesImages = {};
        const qrCodesCopied = {};

        if (resp.data) {
          resp.data.forEach(function (qrCode) {
            const qrCodeImage = util.getQRCodeImage(getQRCodeDynamicUrl(qrCode.id)).get(0).outerHTML;
            qrCodesImages[qrCode.id] = qrCodeImage;
            qrCodesCopied[qrCode.id] = false;
          });

          if (store.getState().isAddQRMode) {
            let qrCodes = $('.pages').find('[data-component="qr-code"]');
            if (qrCodes.length === 1 && util.isQRFrameEmpty(qrCodes)) {
              const $qrObj = $($.parseHTML(qrCodesImages[resp.data[0].id]));
              const url = $qrObj.attr('src');
              qrCodes.find('img').attr('src', url);
              store.dispatch(actions.markAsModified());
            } else if (qrCodes.length > 1) {
              const $qrObj = $($.parseHTML(qrCodesImages[resp.data[0].id]));
              const url = $qrObj.attr('src');
              qrCodes.each(function () {
                $(this).find('img').attr('src', url);
              })
              store.dispatch(actions.markAsModified());
            }
            store.dispatch(actions.setIsAddQRMode(false));
          }
        }

        this.setState({ qrCodes: resp.data, isLoading: false, qrCodesImages, qrCodesCopied });

        if (this.props.isFreemium && resp.data.length > 0) {
          const viewCount = resp.data[0].viewCount;
          const remainingScans = constants.MAX_COUNT_FREEMIUM - viewCount;

          this.setState({ freemiumRemainingScans: remainingScans });
        }

        if (triggerClick) {
          $('body').trigger('click');
        }

        setTimeout(() => {
          util.highlightAsideQrs()

          if (window.data.design.qrCodeToAdd) {
            $('#qr-container > [data-qr-code-id="' + window.data.design.qrCodeToAdd + '"]').click();
            window.data.design.qrCodeToAdd = '';
          }
        }, 500);
      }))
    };

    this.onQRCodesModalClose = (bypassLoad, mobileCloseMenu = true) => {
      if (bypassLoad) {
        this.setState({ isQRCodesModalOpen: false, isLoading: false });
      } else {
        this.setState({ isQRCodesModalOpen: false, isLoading: true });
        this.loadQRCodes();
      }

      if (store.getState().isMobileVersion && mobileCloseMenu) {
        store.dispatch(actions.setIsMobileAside(false));
      }
    };

    this.onSaveModalClose = () => {
      this.setState({ isSaveModalOpen: false });
    }

    this.openCreateQRDesignModal = () => {
      this.setState({ isCreateQRDesignModalOpen: true });
    }

    this.onCreateQRDesignModalClose = () => {
      this.setState({ isCreateQRDesignModalOpen: false });
    }

    this.createQRCode = (mode) => {
      if (!this.props.hasPdfPermission && this.state.qrCodes.length > 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
        return;
      }

      let qrCodeType = mode.indexOf('landing-page') > -1 ? 'landing-page' : mode.indexOf('online-menu') > -1 ? 'online-menu' : mode;

      this.setState({ isQRCodesModalOpen: true, 'mode': mode, 'qrCode': '', customUrl: '', 'qrCodeType': qrCodeType });
    };

    this.preview = (qrCode, ev) => {
      ev.stopPropagation();

      if (!this.props.hasPdfPermission && this.state.freemiumRemainingScans <= 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });

        return;
      }

      window.open(getQRCodeDynamicUrl(qrCode.id), '_blank').focus();
      util.hideDropdown();
    };

    this.edit = (qrCode, ev) => {
      ev.stopPropagation();

      if (!this.props.hasPdfPermission && this.state.freemiumRemainingScans <= 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });

        return;
      }

      if (qrCode.type === 'online-menu') {
        const _this = this;
        const locationId = store.getState().locationId || window.data.design.locationId;

        ooService.getStatusForBusiness(locationId).then(function (resp) {
          console.log(resp);
          let locData = resp.data;
          _this.setState({
            isQRCodesModalOpen: true,
            mode: 'online-menu',
            qrCode,
            omLocationData: locData
          });
        });
      } else {
        // let newMode = qrCode.type === 'saved-design' ? 'saved-design-edit' : qrCode.type;
        let newMode = qrCode.type;
        this.setState({
          isQRCodesModalOpen: true,
          mode: newMode,
          customUrl: qrCode.type === 'custom-url' || qrCode.type === 'facebook' || qrCode.type === 'online-ordering' || qrCode.type === 'pdf' ? qrCode.url : '',
          qrCode,
        });
      }
      util.hideDropdown();
    };

    this.rename = (qrCode, ev) => {
      ev.stopPropagation();

      if (!this.props.hasPdfPermission && this.state.freemiumRemainingScans <= 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });

        return;
      }

      this.setState({
        isQRCodesModalOpen: true,
        mode: 'rename',
        qrCode,
      });

      util.hideDropdown();
    };

    this.download = (qrCode, ev) => {
      ev.stopPropagation();

      if (!this.props.hasPdfPermission && this.state.freemiumRemainingScans <= 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });

        return;
      }

      if (qrCode.type === 'upload') {
        jQuery.fileDownload(constants.appPrefix + '/api/images/download?key=' + qrCode.url).done(() => { }).fail(() => { })
      } else {
        let name = 'qrcode.png';
        let qrCodeImage = util.getQRCodeCanvas(getQRCodeDynamicUrl(qrCode.id)).get(0).toDataURL("image/png");

        const dl = document.createElement('a');
        dl.download = name;
        dl.href = qrCodeImage;
        dl.click();
      }

      util.hideDropdown();
    };

    this.delete = (qrCode, ev) => {
      ev.stopPropagation();

      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: 'This QR Code will be disabled and removed from your library.',
        acceptLabel: 'Yes, remove',
        declineLabel: 'Cancel',
        onAccept: () => {
          this.setState({ isLoading: true });
          qrCodeService.removeQRCode(qrCode.id).then(response => {
            this.setState({ qrCodes: this.state.qrCodes.filter(it => it.id !== qrCode.id), isLoading: false });

            if (qrCode.url === this.props.designId) {
              window.data.design.qrCodeId = '';
              $('body').trigger('click');
            }
          })
        },
      });

      util.hideDropdown();
    };

    this.upgrade = (ev) => {
      ev.stopPropagation();

      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
    };

    this.upload = () => {
      if (!this.props.hasPdfPermission) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
        return;
      }

      $('#qr-upload-input').trigger('click');
    };

    this.onChangeUploadField = (event) => {
      this.forceUpdate();

      if (event.target.files.length > 0) {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);

        this.setState({ isLoading: true });

        memberService.uploadMemberQRCode(this.props.memberId, formData).then(resp => {
          console.log(resp);
          const path = resp.data;

          const qrCodeDto = {
            type: 'upload',
            url: path,
            memberId: this.props.memberId,
            locationId: this.props.locationId
          }

          qrCodeService.createQRCode(qrCodeDto).then((resp) => {
            this.loadQRCodes();
            this.openCreateQRDesignModal();
          });
        });
      }
    }

    this.handleLandingPageQRCode = () => {
      if (!this.props.hasPdfPermission && this.state.qrCodes.length > 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
        return;
      }

      const _this = this;

      qrCodeService.getMemberLandingPages(this.props.memberId, false).then(resp => {
        const landingPages = (resp.data || []);

        if (landingPages.length == 1 && !landingPages[0].published) {
          _this.setState({ landingPageId: landingPages[0].id });
          this.createQRCode('landing-page-publish');
        } else if (landingPages.length > 0) {
          this.createQRCode('landing-page');
        } else {
          this.createQRCode('landing-page-new');
        }
      });
    }

    this.handleOnlineMenuQRCode = () => {
      if (!this.props.hasPdfPermission && this.state.qrCodes.length > 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
        return;
      }

      this.setState({ isLoading: true });

      const _this = this;
      // this.getOnlineMenu().then(function (resp) {
      const locationId = store.getState().locationId || window.data.design.locationId;
      ooService.getStatusForBusiness(locationId).then(function (resp) {
        console.log(resp);
        let data = resp.data;

        if (data.businessId && data.status === "PUBLISHED") {
          const qrCodeDto = {
            type: 'online-menu',
            url: window.location.origin + '/places/qr/' + locationId,
            memberId: _this.props.memberId,
            locationId: locationId
          }

          qrCodeService.createQRCode(qrCodeDto).then((resp) => {
            _this.loadQRCodes(true);
            _this.openCreateQRDesignModal();
          });
        } else {
          if (data.location && data.location.menuCount > 0) {
            _this.createQRCode('online-menu-publish');
          } else {
            _this.createQRCode('online-menu-new');
          }
        }
      })
    }

    this.getOnlineMenu = () => {
      return dashboardService.getOnlineMenuStatus();
    }

    this.createCurrentDesignQR = () => {
      this.setState({ isLoading: true });

      const qrCodeDto = {
        type: 'saved-design',
        url: this.props.designId,
        memberId: this.props.memberId,
        locationId: this.props.locationId
      }

      qrCodeService.createQRCode(qrCodeDto).then((resp) => {
        this.loadQRCodes(true);
        window.data.design.qrCodeId = resp.data.id;
        window.data.design.qrCreated = true;
        if (this.state.isSaveModalOpen) {
          this.onSaveModalClose();
        }
        this.openCreateQRDesignModal();
        this.setState({ createQRAfterSharing: false });
      });
    }

    this.handleCreateCurrentDesignQRCode = () => {
      if (!this.props.hasPdfPermission && this.state.qrCodes.length > 0) {
        window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
        return;
      }

      if (!util.hasDesignName(this.props.designName)) {
        this.setState({ createQRAfterSharing: true });
        util.nextTick(() => {
          this.setState({ isSaveModalOpen: true });
        })
        return;
      }
      this.createCurrentDesignQR();
    }

    this.formatDate = (date) => {
      return moment(new Date(date)).format('MMM DD[,] YYYY');
    }

    this.copyQrLink = (ev, qrCode) => {
      ev.stopPropagation();
      let qrCodesCopied = this.state.qrCodesCopied;
      qrCodesCopied[qrCode.id] = true;
      this.setState({ qrCodesCopied });

      setTimeout(() => {
        let qrCodesCopied = this.state.qrCodesCopied;
        qrCodesCopied[qrCode.id] = false;
        this.setState({ qrCodesCopied });
      }, 3000);

      copyText(getQRCodeDynamicUrl(qrCode.id));
    }

    this.onFreemiumClickNew = () => {
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: this.props.setActiveMember });
    }
  }

  componentDidMount() {
    if (this.props.isLogged) {
      this.loadQRCodes();
    }
  }

  goBack() {
    this.props.goToRoot()
  }

  render(props, state) {
    let qrImages = '';
    qrImages = !state.isLoading && !props.isFreemium ? state.qrCodes.map((qrCode, index) => {
      const qrCodeImage = state.qrCodesImages[qrCode.id];

      return (
        <div className="component template saved-qr-code" data-qr-code-id={qrCode.id} data-component="qr-code" style="display: inline-block; vertical-align: top;">
          {qrCode.type === 'upload'
            ? <div className="qr" style="display: table-row;" data-component="qr-code" data-ratio="1">
              <img className="img" src={'https://timber.mhmcdn.com/' + qrCode.url} alt={''} />
            </div>
            : <div className="qr" style="display: table-row;" data-component="qr-code" data-ratio="1" dangerouslySetInnerHTML={{ __html: qrCodeImage }} />
          }

          <div className="label">
            <div className={'qr-type ' + (qrCode.type === 'saved-design' ? '' : 'hidden')}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-saved-design"} />
              </svg>
              Saved Design
            </div>

            <div className={'qr-type ' + (qrCode.type == 'landing-page' ? '' : 'hidden')}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-lp"} />
              </svg>
              Link Page
            </div>

            <div className={'qr-type ' + (qrCode.type === 'upload' ? '' : 'hidden')}>
              Upload
            </div>

            <div className={'qr-type ' + (qrCode.type === 'online-menu' ? '' : 'hidden')}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-om"} />
              </svg>
              Online Menu
            </div>

            <div className={'qr-type ' + (qrCode.type === 'pdf' ? '' : 'hidden')}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-pdf"} />
              </svg>
              PDF
            </div>

            <div className={'qr-type ' + (qrCode.type !== 'saved-design' &&
              qrCode.type !== 'upload' &&
              qrCode.type !== 'landing-page' &&
              qrCode.type !== 'online-menu' &&
              qrCode.type !== 'pdf' ? ''
              : 'hidden')}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-website"} />
              </svg>
              Website
            </div>


            <div className={qrCode.type === 'saved-design' ? '' : 'hidden'}>
              {qrCode.name || qrCode.savedDesignName}
            </div>

            <div className={qrCode.type == 'landing-page' ? '' : 'hidden'}>
              {qrCode.name}
            </div>

            <div className={qrCode.type === 'upload' ? '' : 'hidden'}>
              {qrCode.name || qrCode.url.split("/").pop().split('-')[0] + qrCode.url.substr(-4)}
            </div>

            <div className={qrCode.type === 'online-menu' ? '' : 'hidden'}>
              {qrCode.name}
            </div>

            <div className={qrCode.type !== 'saved-design' && qrCode.type !== 'upload' && qrCode.type !== 'landing-page' && qrCode.type !== 'online-menu' ? '' : 'hidden'}>
              {qrCode.name || qrCode.url.replace('http://', '').replace('https://', '')}
            </div>

            <div className='last-update'>Last Update: {this.formatDate(qrCode.updatedDate)}</div>
            <div className='scans'>{qrCode.viewCount + (qrCode.viewCount === 1 ? ' scan' : ' scans')}</div>
            <div className="copy-link" onClick={(ev) => this.copyQrLink(ev, qrCode)}>
              <svg>
                <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-copy-link"} />
              </svg>
              {state.qrCodesCopied[qrCode.id] ? 'Copied' : 'Copy link'}
            </div>
          </div>

          <div className="dropdown dropdown-qr-code">
            <div className="dropdown-toggle">
              <EllipsisOutlined />
            </div>
            <div className="dropdown-menu medium" data-close="no">
              <ul className="dropdown-options">
                <li onClick={(ev) => this.preview(qrCode, ev)} className={qrCode.type === 'upload' ? 'hidden' : ''}>
                  <svg class="design-drop-icon"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-preview-eye"} /></svg>
                  Preview
                </li>
                <li onClick={(ev) => this.edit(qrCode, ev)} className={qrCode.type === 'upload' ? 'hidden' : ''}>
                  <svg class="design-drop-icon">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-edit-design"} />
                  </svg>
                  Edit
                </li>
                <li onClick={(ev) => this.rename(qrCode, ev)} className={qrCode.type === 'upload' ? 'hidden' : ''}>
                  <svg class="design-drop-icon"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-rename-design"}></use></svg>
                  Rename
                </li>
                <li onClick={(ev) => this.download(qrCode, ev)}>
                  <svg class="design-drop-icon"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-download-qr"}></use></svg>
                  Download
                </li>
                {!props.isFreemium ? <li onClick={(ev) => this.delete(qrCode, ev)}>
                  <svg class="design-drop-icon"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-delete-design"}></use></svg>
                  Delete
                </li> : ''}
              </ul>
            </div>
          </div>
        </div >
      )
    }) : '';

    const elements = state.isLoading ? <Spinner /> : <div id='qr-container'>{qrImages}</div>;

    return (
      <div id="app-aside-qr-codes" className="aside-text aside-qr-codes" >
        <header>
          {props.isFreemium && <div className="dropdown">
            <a className="dropdown-toggle btn primary medium" onClick={() => this.onFreemiumClickNew()}>
              + New QR Code
              <img src="https://timber.mhmcdn.com/site/marketing/icons/ProStar.svg" alt="pro star" />
            </a>
          </div>}
          {!props.isFreemium && <div className="dropdown">
            <a className="dropdown-toggle btn primary medium">+ New QR Code</a>
            <div className="dropdown-menu">
              <div className="angle right" />
              <ul>
                <li>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-saved-design"} />
                  </svg>
                  <a onClick={() => this.createQRCode('saved-design')}>Saved Design</a>
                </li>
                <li>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-om"} />
                  </svg>
                  <a onClick={() => this.handleOnlineMenuQRCode()}>Online Menu</a>
                </li>
                <li>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-lp"} />
                  </svg>
                  <a onClick={() => this.handleLandingPageQRCode()}>Link Page</a>
                </li>
                <li>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-website"} />
                  </svg>
                  <a onClick={() => this.createQRCode('custom-url')}>Website</a>
                </li>
                <li>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-pdf"} />
                  </svg>
                  <a onClick={() => this.createQRCode('pdf')}>PDF</a>
                </li>
                <li>
                  <svg>
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-current-design"} />
                  </svg>
                  <a onClick={() => this.handleCreateCurrentDesignQRCode()}>Current Design</a>
                </li>
              </ul>
            </div>
          </div>}
        </header>
        <div className="scroller">
          <div className="link-images qr-code-link-images">
            <div>
              {props.isAdmin &&
                <div>
                  <input type="file" name="image" id="qr-upload-input" onChange={this.onChangeUploadField.bind(this)} accept="image/*" className="hidden" />
                  {!props.isFreemium ? <p><a className={'lk'} onClick={() => this.upload()} style="cursor: pointer;">Upload Code</a> (admins/designers only)</p> : ''}
                </div>
              }
            </div>

            {state.qrCodes.length > 0 && !props.isFreemium && <h6>My QR Codes</h6>}
            {!state.isLoading && (state.qrCodes.length === 0 || props.isFreemium) && <h6 style="font-weight: normal;">You have not saved any QR codes yet! Click the button above to get started.</h6>}

            <div className="components qr-codes">
              {elements}
            </div>
          </div>
        </div>

        {
          state.isQRCodesModalOpen
            ? <QRCodesModal
              open={state.isQRCodesModalOpen}
              mode={state.mode}
              qrCode={state.qrCode}
              qrCodes={state.qrCodes}
              qrCodeType={state.qrCodeType}
              customUrl={state.customUrl}
              omLocationData={state.omLocationData}
              landingPageId={state.landingPageId}
              onModalClose={this.onQRCodesModalClose}
              openCreateQRDesignModal={this.openCreateQRDesignModal} />
            : null
        }

        <SaveModal saveMode={'sharing'}
          createQRAfterSharing={state.createQRAfterSharing}
          createQRCode={this.createCurrentDesignQR}
          open={state.isSaveModalOpen}
          quitAfterSaving={false}
          onModalClose={this.onSaveModalClose} />

        <CreateQRDesignModal
          open={state.isCreateQRDesignModalOpen}
          onClose={this.onCreateQRDesignModalClose} />
      </div >
    )
  }
}
